// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__3ffC2","search":"Settings_search__3ePiX","filter":"Settings_filter__2olxg"};